import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from 'src/app/core/services/profile.service';
import { Connections } from 'src/app/core/interface/auth.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { SearchService } from 'src/app/core/services/search.service';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { ChatService } from 'src/app/core/services/chat.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-all-request-modal',
  templateUrl: './all-request-modal.component.html',
  styleUrls: ['./all-request-modal.component.scss']
})
export class AllRequestModalComponent implements OnInit {

  allRequestsConnections: any;
  imgURL: any = environment.url;
  contentLoader: boolean = false;
  @Input() subscribe;
  connectionCount = 0;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _profileService: ProfileService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private _searchService: SearchService,
    private chatService: ChatService,
    private _router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (!this.subscribe) {
      this.fetchAllConnection()
    } else {
      this.fetchAllSubscribers();
    }
  }
  fetchAllConnection() {
    // this.contentLoader = true;
    this.contentLoader = true;
    this._profileService.fetchAllRequestConnections().subscribe(
      (response: any) => {
        this.contentLoader = false;
        if (response.success) {
          this.allRequestsConnections = response.data.connections;
          this.connectionCount = this.allRequestsConnections.length;

          var that = this;
          this.allRequestsConnections.forEach(element => {
            if (element.user.avatar)
              element.user.avatar = that.imgURL + element.user.avatar;
            else
              element.user.avatar = null;
          });
        }
      }, (error) => {
        this.contentLoader = false;
      });
  }

  fetchAllSubscribers() {
    this.contentLoader = true;
    this._profileService.fetchSubscribers('?status=pending&request_sent_to_me=1').subscribe(
      (response: any) => {
        this.contentLoader = false;
        if (response.success) {
          this.allRequestsConnections = response.data.subscribers;
          this.connectionCount = this.allRequestsConnections.length;
          var that = this;
          this.allRequestsConnections.forEach(element => {
            if (element.user.avatar)
              element.user.avatar = that.imgURL + element.user.avatar;
            else
              element.user.avatar = null;
          });
        }
      }, (error) => {
        this.contentLoader = false;
      });
  }
  redirectToUser(userId) {
    this.modalService.dismissAll();
    this._router.navigate(['/other-profile', userId]);
  }

  closeDialog() {
    this.activeModal.close();
  }

  acceptConnection(userId) {
    if (this.contentLoader) {
      return;
    }
    this.contentLoader = true;
    const params: Connections = {
      connection: {
        status: 'accepted'
      }
    };
    this._searchService.acceptConnection(userId, params).subscribe(
      (response: any) => {
        this.chatService.acceptRequest.next(response.data.connection);
        this.contentLoader = false;
        this.authService.setProfileCount();
        // const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        this.connectionCount -= 1;
        this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_ADD_SUCCESS);
        // modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_ADD_SUCCESS;
        // modelRef.result.then(
        // () => { if (this.connectionCount === 0) { this.closeDialog(); } },
        // (reason) => { if (this.connectionCount === 0) { this.closeDialog(); } }
        // );
        if (this.connectionCount === 0) { this.closeDialog(); }
        this.ngOnInit();

      }, (error: any) => {
        this.contentLoader = false;
        this.ngOnInit();

      });
  }

  rejectConnection(userId) {
    if (this.contentLoader) {
      return;
    }
    this.contentLoader = true;
    this._searchService.deleteConnection(userId).subscribe(
      (response: any) => {
        this.contentLoader = false;
        if (response.success) {
          this.ngOnInit();
          this.authService.setProfileCount();
          this.contentLoader = false;
          // const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          this.connectionCount -= 1;
          this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_REJECT_SUCCESS);
          // modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_REJECT_SUCCESS;
          // modelRef.result.then(
          // () => { if (this.connectionCount === 0) { this.closeDialog(); } },
          // (reason) => { if (this.connectionCount === 0) { this.closeDialog(); } }
          // );
          if (this.connectionCount === 0) { this.closeDialog(); }

        }
      }, (error: any) => {
        this.contentLoader = false;
      });
  }

  acceptRejectSubscriber(connection, isAccept) {

    if (this.contentLoader) {
      return;
    }
    this.contentLoader = true;
    const status = (isAccept) ? "subscribed" : "unsubscribed";
    this._profileService.profileUnsubscribe(status, connection.id).subscribe((response) => {
      this.authService.setProfileCount();
      this.contentLoader = false;
      if (response.success) {
        // const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        if (connection.is_paid_subscriber) {
          if (isAccept) {
            this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.ACCEPT_SUBSCRIPTION);
          } else {
            this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.DECLINE_SUBSCRIPTION);
          }
        } else {
          if (isAccept) {
            this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.ACCEPT_SUBSCRIBER);
          } else {
            this.toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.DECLINE_SUBSCRIBER);
          }
        }
        // if (connection.is_paid_subscriber) {
        //   modalRef.componentInstance.message = (isAccept) ? LITERALS.AUTH.SUCCESS_MESSAGES.ACCEPT_SUBSCRIPTION : LITERALS.AUTH.SUCCESS_MESSAGES.DECLINE_SUBSCRIPTION;
        // } else {
        //   modalRef.componentInstance.message = (isAccept) ? LITERALS.AUTH.SUCCESS_MESSAGES.ACCEPT_SUBSCRIBER : LITERALS.AUTH.SUCCESS_MESSAGES.DECLINE_SUBSCRIBER;
        // }
        this.allRequestsConnections = this.allRequestsConnections.filter((ele) => {
          return ele.id != connection.id;
        });
        this.connectionCount = this.allRequestsConnections.length;
        if (this.connectionCount === 0) { this.closeDialog(); }
        // modalRef.result.then(
        //   () => { if (this.connectionCount === 0) { this.closeDialog(); } },
        //   (reason) => { if (this.connectionCount === 0) { this.closeDialog(); } }
        // );
      }
      else if (!response.success) {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        if (connection.is_paid_subscriber) {
          modalRef.componentInstance.message = (isAccept) ? LITERALS.AUTH.ERROR_MESSAGES.ACCEPT_SUBSCRIPTION : LITERALS.AUTH.ERROR_MESSAGES.DECLINE_SUBSCRIPTION;
        } else {
          modalRef.componentInstance.message = (isAccept) ? LITERALS.AUTH.ERROR_MESSAGES.ACCEPT_SUBSCRIBER : LITERALS.AUTH.ERROR_MESSAGES.DECLINE_SUBSCRIBER;
        }
      }
    });
  }

}